const newsletterTypes = {
  SIGN_UP_NEWSLETTER_START: "SIGN_UP_NEWSLETTER_START",
};

export default newsletterTypes;
